import { render, staticRenderFns } from "./collectTimeReport.vue?vue&type=template&id=13277e82&scoped=true"
import script from "./collectTimeReport.vue?vue&type=script&lang=js"
export * from "./collectTimeReport.vue?vue&type=script&lang=js"
import style0 from "./collectTimeReport.vue?vue&type=style&index=0&id=13277e82&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13277e82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13277e82')) {
      api.createRecord('13277e82', component.options)
    } else {
      api.reload('13277e82', component.options)
    }
    module.hot.accept("./collectTimeReport.vue?vue&type=template&id=13277e82&scoped=true", function () {
      api.rerender('13277e82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/Report/collectTimeReport.vue"
export default component.exports